import { ViewType } from "api/type";

const rightInvalidFace =
  "https://clinic-os.com/flow-assets/body-scanner-ai/face-pose-bold/face-procedures-transparent-right-bold.png";
const rightValidFace =
  "https://clinic-os.com/flow-assets/body-scanner-ai/face-pose-bold/face-procedures-valid-right-bold.png";
const rightObliqueInvalidFace =
  "https://clinic-os.com/flow-assets/body-scanner-ai/face-pose-bold/face-procedures-transparent-right-oblique-bold.png";
const rightObliqueValidFace =
  "https://clinic-os.com/flow-assets/body-scanner-ai/face-pose-bold/face-procedures-valid-right-oblique-bold.png";
const frontInvalidFace =
  "https://clinic-os.com/flow-assets/body-scanner-ai/face-pose-bold/face-procedures-transparent-front-bold.png";
const frontValidFace =
  "https://clinic-os.com/flow-assets/body-scanner-ai/face-pose-bold/face-procedures-valid-front-bold.png";
const leftObliqueInvalidFace =
  "https://clinic-os.com/flow-assets/body-scanner-ai/face-pose-bold/face-procedures-transparent-left-oblique-bold.png";
const leftObliqueValidFace =
  "https://clinic-os.com/flow-assets/body-scanner-ai/face-pose-bold/face-procedures-valid-left-oblique-bold.png";
const leftInvalidFace =
  "https://clinic-os.com/flow-assets/body-scanner-ai/face-pose-bold/face-procedures-transparent-left-bold.png";
const leftValidFace =
  "https://clinic-os.com/flow-assets/body-scanner-ai/face-pose-bold/face-procedures-valid-left-bold.png";

const rightInvalidBody =
  "https://clinic-os.com/flow-assets/body-scanner-ai/body-pose-bold/body-procedures-transparent-right-bold.png";
const rightValidBody =
  "https://clinic-os.com/flow-assets/body-scanner-ai/body-pose-bold/body-procedures-valid-right-bold.png";
const rightObliqueInvalidBody =
  "https://clinic-os.com/flow-assets/body-scanner-ai/body-pose-bold/body-procedures-transparent-right-oblique-bold.png";
const rightObliqueValidBody =
  "https://clinic-os.com/flow-assets/body-scanner-ai/body-pose-bold/body-procedures-valid-right-oblique-bold.png";
const frontInvalidBody =
  "https://clinic-os.com/flow-assets/body-scanner-ai/body-pose-bold/body-procedures-transparent-front-bold.png";
const frontValidBody =
  "https://clinic-os.com/flow-assets/body-scanner-ai/body-pose-bold/body-procedures-valid-front-bold.png";
const leftObliqueInvalidBody =
  "https://clinic-os.com/flow-assets/body-scanner-ai/body-pose-bold/body-procedures-transparent-left-oblique-bold.png";
const leftObliqueValidBody =
  "https://clinic-os.com/flow-assets/body-scanner-ai/body-pose-bold/body-procedures-valid-left-oblique-bold.png";
const leftInvalidBody =
  "https://clinic-os.com/flow-assets/body-scanner-ai/body-pose-bold/body-procedures-transparent-left-bold.png";
const leftValidBody =
  "https://clinic-os.com/flow-assets/body-scanner-ai/body-pose-bold/body-procedures-valid-left-bold.png";
const backInvalidBody =
  "https://clinic-os.com/flow-assets/body-scanner-ai/body-pose-bold/body-procedures-transparent-back-bold.png";
const backValidBody =
  "https://clinic-os.com/flow-assets/body-scanner-ai/body-pose-bold/body-procedures-valid-front-bold.png";

const rightInvalidBreast =
  "https://clinic-os.com/flow-assets/body-scanner-ai/breast-pose-bold/breast-procedures-transparent-right-bold.png";
const rightValidBreast =
  "https://clinic-os.com/flow-assets/body-scanner-ai/breast-pose-bold/breast-procedures-valid-right-bold.png";
const rightObliqueInvalidBreast =
  "https://clinic-os.com/flow-assets/body-scanner-ai/breast-pose-bold/breast-procedures-transparent-right-oblique-bold.png";
const rightObliqueValidBreast =
  "https://clinic-os.com/flow-assets/body-scanner-ai/breast-pose-bold/breast-procedures-valid-right-oblique-bold.png";
const frontInvalidBreast =
  "https://clinic-os.com/flow-assets/body-scanner-ai/breast-pose-bold/breast-procedures-transparent-front-bold.png";
const frontValidBreast =
  "https://clinic-os.com/flow-assets/body-scanner-ai/breast-pose-bold/breast-procedures-valid-front-bold.png";
const leftObliqueInvalidBreast =
  "https://clinic-os.com/flow-assets/body-scanner-ai/breast-pose-bold/breast-procedures-transparent-left-oblique-bold.png";
const leftObliqueValidBreast =
  "https://clinic-os.com/flow-assets/body-scanner-ai/breast-pose-bold/breast-procedures-valid-left-oblique-bold.png";
const leftInvalidBreast =
  "https://clinic-os.com/flow-assets/body-scanner-ai/breast-pose-bold/breast-procedures-transparent-left-bold.png";
const leftValidBreast =
  "https://clinic-os.com/flow-assets/body-scanner-ai/breast-pose-bold/breast-procedures-valid-left-bold.png";

export type PoseType = {
  validImage: string;
  invalidImage: string;
  viewType: ViewType;
};

export type PoseListType = {
  [viewType: string]: PoseType;
};

export const poseList: PoseListType = {
  headFrontPose: {
    validImage: frontValidFace,
    invalidImage: frontInvalidFace,
    viewType: ViewType.HEAD_FRONT,
  },
  headLeftObliquePose: {
    validImage: leftObliqueValidFace,
    invalidImage: leftObliqueInvalidFace,
    viewType: ViewType.HEAD_LEFT_45,
  },
  headLeftPose: {
    validImage: leftValidFace,
    invalidImage: leftInvalidFace,
    viewType: ViewType.HEAD_LEFT,
  },
  headRightObliquePose: {
    validImage: rightObliqueValidFace,
    invalidImage: rightObliqueInvalidFace,
    viewType: ViewType.HEAD_RIGHT_45,
  },
  headRightPose: {
    validImage: rightValidFace,
    invalidImage: rightInvalidFace,
    viewType: ViewType.HEAD_RIGHT,
  },

  bodyFrontPose: {
    validImage: frontValidBody,
    invalidImage: frontInvalidBody,
    viewType: ViewType.BODY_FRONT,
  },
  bodyLeftObliquePose: {
    validImage: leftObliqueValidBody,
    invalidImage: leftObliqueInvalidBody,
    viewType: ViewType.BODY_LEFT_45,
  },
  bodyLeftPose: {
    validImage: leftValidBody,
    invalidImage: leftInvalidBody,
    viewType: ViewType.BODY_LEFT,
  },
  bodyRightObliquePose: {
    validImage: rightObliqueValidBody,
    invalidImage: rightObliqueInvalidBody,
    viewType: ViewType.BODY_RIGHT_45,
  },
  bodyRightPose: {
    validImage: rightValidBody,
    invalidImage: rightInvalidBody,
    viewType: ViewType.BODY_RIGHT,
  },
  bodyBackPose: {
    validImage: backValidBody,
    invalidImage: backInvalidBody,
    viewType: ViewType.BODY_BACK,
  },

  breastFrontPose: {
    validImage: frontValidBreast,
    invalidImage: frontInvalidBreast,
    viewType: ViewType.TORSO_FRONT,
  },
  breastLeftObliquePose: {
    validImage: leftObliqueValidBreast,
    invalidImage: leftObliqueInvalidBreast,
    viewType: ViewType.TORSO_LEFT_45,
  },
  breastLeftPose: {
    validImage: leftValidBreast,
    invalidImage: leftInvalidBreast,
    viewType: ViewType.TORSO_LEFT,
  },
  breastRightPose: {
    validImage: rightValidBreast,
    invalidImage: rightInvalidBreast,
    viewType: ViewType.TORSO_RIGHT,
  },
  breastRightObliquePose: {
    validImage: rightObliqueValidBreast,
    invalidImage: rightObliqueInvalidBreast,
    viewType: ViewType.TORSO_RIGHT_45,
  },
  noPose: {
    validImage: "",
    invalidImage: "",
    viewType: ViewType.NONE,
  },
};
